import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[darkStyle]',
})
export class DarkStyleDirective {
  constructor(el: ElementRef) {
    el.nativeElement.style.background = '#2D79DB';
    el.nativeElement.style.color = '#FFFFFF';
  }
}
